import React, { Fragment, useEffect, useState } from "react";
import { Alert, Pagination, Table } from "react-bootstrap";
import { REPORTES_TABLE_ROWS } from "../../../config";
import GreenPoint from "./GreenPoint";
import RedPoint from "./RedPoint";

const PaginationGroup = ({ active = 1, totalTables = 5, handlePagination }) => {
    const items = [];
    for (let number = 1; number <= totalTables; number++) {
        items.push(
            <Pagination.Item
                key={number}
                active={number === active}
                onClick={() => handlePagination(number)}
            >
                {number}
            </Pagination.Item>
        );
    }

    return <Pagination size="sm">{items}</Pagination>;
};

const TablaLeads = ({ leads }) => {
    const TABLE_SIZE = REPORTES_TABLE_ROWS || 50

    const TOTAL_TABLES = Math.ceil(leads.length / TABLE_SIZE);

    const [paginatedLeads, setPaginatesLeads] = useState([]);
    const [activeTable, setActiveTable] = useState(1);

    function handlePagination(number) {
        setPaginatesLeads(paginate(leads, number));
        setActiveTable(number);
    }

    function paginate(leads, tableNumber) {
        return leads.slice(
            (tableNumber - 1) * TABLE_SIZE,
            tableNumber * TABLE_SIZE
        );
    }

    useEffect(() => {
        setPaginatesLeads(paginate(leads, 1));
    }, [leads]);

    return (
        <Fragment>
            <div style={{ maxHeight: "600px", overflowY: "scroll" }}>
                <Table striped bordered hover style={{ marginBottom: "0" }}>
                    <thead>
                        <tr>
                            <th>Fecha</th>
                            <th>DNI</th>
                            <th>Nombre</th>
                            <th>Apellido</th>
                            <th>Email</th>
                            <th>Telefono</th>
                            <th>Localidad</th>
                            <th>Provincia</th>
                        </tr>
                    </thead>
                    <tbody>
                        {paginatedLeads.length
                            ? paginatedLeads.map((e) => {
                                  return (
                                      <tr key={e.id}>
                                          <td>{e.fecha || "----"}</td>
                                          <td
              
                                          >
                                              {e.dniValidado ? (
                                                  <GreenPoint />
                                              ) : (
                                                  <RedPoint />
                                              )}
                                              {e.dni || "----"}
                                          </td>
                                          <td>{e.nombre || "----"}</td>
                                          <td>{e.apellido || "----"}</td>
                                          <td
                
                                          >
                                              {e.emailValidado ? (
                                                  <GreenPoint />
                                              ) : (
                                                  <RedPoint />
                                              )}
                                              {e.email || "----"}
                                          </td>
                                          <td>
                                              {e.smsValidado ? (
                                                  <GreenPoint />
                                              ) : (
                                                  <RedPoint />
                                              )}
                                              {e.prefijo + " " + e.telefono ||
                                                  "----"}
                                          </td>
                                          <td>
                                              {e.localidad
                                                  ? e.localidad.descripcion
                                                  : "----"}
                                          </td>
                                          <td>
                                              {e.provincia
                                                  ? e.provincia.descripcion
                                                  : "----"}
                                          </td>
                                      </tr>
                                  );
                              })
                            : null}
                    </tbody>
                </Table>
                {!paginatedLeads.length ? (
                    <Alert variant="secondary" style={{marginTop:'2rem',textAlign:'center'}}>
                        No se encontraron filas para mostrar.
                    </Alert>
                ) : null}
            </div>
            <div
                style={{
                    margin: "0 auto",
                    textAlign: "center",
                    marginBottom: "1rem",
                }}
            >
                {TOTAL_TABLES > 1 ? (
                    <PaginationGroup
                        handlePagination={handlePagination}
                        active={activeTable}
                        totalTables={TOTAL_TABLES}
                    />
                ) : null}
            </div>
        </Fragment>
    );
};

export default TablaLeads;



// WEBPACK FOOTER //
// ./src/scenes/reportes/components/TablaLeads.js